import React from 'react'

const Awesome = ({ className }: { className?: string }) => {
    return (
        <svg className={className} fill="none" height="26" viewBox="0 0 26 26" width="26" xmlns="http://www.w3.org/2000/svg">
<path d="M18.4167 3.25C17.6757 5.928 16.7213 6.84288 14.0833 7.58333C16.7213 8.32379 17.6757 9.23867 18.4167 11.9167C19.1577 9.23867 20.1121 8.32379 22.75 7.58333C20.1121 6.84288 19.1577 5.928 18.4167 3.25ZM10.8333 7.58333C9.53604 12.2693 7.86717 13.871 3.25 15.1667C7.86717 16.4623 9.53604 18.064 10.8333 22.75C12.1306 18.064 13.7995 16.4623 18.4167 15.1667C13.7995 13.871 12.1306 12.2693 10.8333 7.58333Z" fill="currentColor"></path>
</svg>
    )
}

export default Awesome
